import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['suggestChangesModal'] = { state: null },
  action: Action,
): RootState['suggestChangesModal'] {
  switch (action.type) {
    case 'SUGGEST_CHANGES_MODAL_SET': {
      return action.payload
    }

    default:
      return state
  }
}
